module.exports = __webpack_public_path__ + "img/home-bg.92635564.png";